<template>
  <div class="print-model">
    <div id="printMe" ref="printMe" v-if="!loading">
      <SafesTransfer :item="item" />
    </div>
  </div>
</template>
<script>
import SafesTransfer from './components/safesTransfers.vue'
export default {
  data() {
    return {
      path: '/expenses',
      logo: localStorage.getItem('logo'),
      item: {},
      loading: true
    }
  },
  methods: {
    getitem() {
      this.item = this.$parent.printedSafesTransfer
      this.loading = false
      var myel = this
      setTimeout(function () {
        var text = document.getElementById('printMe').innerHTML
        document.getElementById('printMe').remove()
        var myframe = document.getElementById('inviceIframe')
        myframe.contentDocument.body.innerHTML = text
        setTimeout(function () {
          myframe.focus()
          myframe.contentWindow.print()
          myel.colse()
        }, 100)
      }, 20)
    },
    colse() {
      this.$parent.printedSafesTransfer = false
    }
  },
  mounted() {
    this.getitem()
  },
  components: {
    SafesTransfer
  },
  props: ['options']
}
</script>
